// DS: I3
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Eye2: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="currentColor" fillRule="evenodd" transform="translate(2 5)">
        <path d="M10 0C6.702 0 3.678 2.185.85 6.271L0 7.5l.85 1.229C3.678 12.815 6.702 15 10 15s6.322-2.185 9.15-6.271L20 7.5l-.85-1.229C16.322 2.185 13.298 0 10 0zm0 2c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm1 2L9 6l2 2 2-2-2-2z" />
      </g>
    </svg>
  </IconWrap>
);
Eye2.displayName = 'Eye2';

export default Eye2;
